//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { IPrivacyTypeManagementDTO } from '../../../DTO/IPrivacyTypeManagementDTO';

//element.Name=PrivacyTypeManagementController result.Name=PrivacyTypeManagementController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.PrivacyTypeManagementController);
/** WebApiController: PrivacyTypeManagementController */
export class PrivacyTypeManagementController extends DefaultDtoControllerProxy<IPrivacyTypeManagementDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'PrivacyTypesManagements', BusinessObjectType.PrivacyTypeManagement);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IPrivacyTypeManagementDTO>
	{
		return (this.axios.get('PrivacyTypesManagements/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
